import React, { useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Checkbox, CircularProgress, FormControl, FormControlLabel, InputLabel, ListItemText, MenuItem, Select } from "@material-ui/core";
import ActionDialog from "../../ActionDialog";
import { editAgreementVisibility } from "../../../../actions";
import { Visibility } from "../../../../util";
import { useManagementAction } from "../../../../hooks/useManagementAction";

const ChangeVisibilityPermission = ({ open, handleCloseDialog, user, fetchUser }) => {
  const { handleManagementAction } = useManagementAction();

  const initialVisibilityPermission = user.contractAgent.visibilityPermission;
  const defaultVisibilityPermission = user.contractAgent.contractAgentClass.visibilityPermission;
  const [loading, setLoading] = useState(false);
  const [selectedVisibility, setSelectedVisibility] = useState(() => initialVisibilityPermission);
  const [useDefault, setUseDefault] = useState(user.contractAgent.defaultVisibilityPermission);

  const isMountedRef = useRef(true);
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const onFinish = () => {
    if (!isMountedRef.current) return;

    setLoading(false);
    handleCloseDialog();
  };

  const handleSubmit = async () => {
    setLoading(true);
    await handleManagementAction({
      body: { editedUserId: user.id, visibility: selectedVisibility },
      managementAction: editAgreementVisibility,
      onComplete: fetchUser,
      setLoading: setLoading,
      onFinish,
      successMessage: "app.edit.sucesfully",
    });
  };

  const handleClose = () => {
    setSelectedVisibility(initialVisibilityPermission);
    handleCloseDialog();
  };

  useEffect(() => {
    setSelectedVisibility(useDefault ? null : initialVisibilityPermission);
  }, [useDefault, initialVisibilityPermission]);

  const getRenderValue = () => {
    const visibilityPermission = useDefault ? defaultVisibilityPermission : selectedVisibility;
    return <FormattedMessage id={`app.manager.visibility.${visibilityPermission}`} />;
  };

  return (
    <ActionDialog
      title="app.edit"
      open={open}
      onAccept={handleSubmit}
      onClose={handleClose}
      textConfirm="app.edit"
      maxWidth="xs"
      disableConfirmButton={loading}
      textToConfirmation={"app.confirm.changeVisibilityPermission"}
    >
      <FormControl
        fullWidth
        variant="outlined"
        size="small"
      >
        <InputLabel id="segment-label">
          <FormattedMessage id="app.manager.visibility" />
        </InputLabel>

        <Select
          labelId="segment-label"
          label={<FormattedMessage id="app.manager.visibility" />}
          value={useDefault ? defaultVisibilityPermission : selectedVisibility}
          renderValue={getRenderValue}
          onChange={(e) => setSelectedVisibility(e.target.value)}
          disabled={useDefault}
        >
          <MenuItem value={Visibility.DIRECT_BELOW}>
            <ListItemText primary={<FormattedMessage id="app.manager.visibility.DIRECT_BELOW" />} />
          </MenuItem>
          <MenuItem value={Visibility.BELOW_AGENTS}>
            <ListItemText primary={<FormattedMessage id="app.manager.visibility.BELOW_AGENTS" />} />
          </MenuItem>
          <MenuItem value={Visibility.ALL_BELOW}>
            <ListItemText primary={<FormattedMessage id="app.manager.visibility.ALL_BELOW" />} />
          </MenuItem>
          <MenuItem value={Visibility.UNLIMITED}>
            <ListItemText primary={<FormattedMessage id="app.manager.visibility.UNLIMITED" />} />
          </MenuItem>
        </Select>
      </FormControl>
      <FormControlLabel
        disabled={loading}
        control={
          <Checkbox
            checked={useDefault}
            onChange={() => setUseDefault((prev) => !prev)}
            color="primary"
          />
        }
        label={<FormattedMessage id="app.manager.useDefault" />}
      />
      {loading && (
        <div style={{ textAlign: "center", marginTop: 12 }}>
          <CircularProgress />
        </div>
      )}
    </ActionDialog>
  );
};

export default ChangeVisibilityPermission;
